import {
    IParsedStackedSymbolName,
    ISymbolStateConfig,
    StateReelSymbol
} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SpinReelController} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelController";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {IReelStopSpinData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {Timeline, TimelineLite, TweenLite} from "gsap";
import {ReelAnimationState} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelAnimationState";

export class ImmortalFruitsReelController extends SpinReelController {

    /**
     * @description To re-order the symbols so that S,M1 and M2 stays on top.
     * @param reelSet
     */
    public reOrderSymbols() {
        let sym: StateReelSymbol;
        const symbols: string[] = ["M2", "M1", "S"];

        symbols.forEach((value: string) => {
            for (let i = 0; i < this._stopReelSet.length; i++) {
                if (this._stopReelSet[i] === value) {
                    sym = this.findSymbol(i - 1)!;
                    sym && this.addChildOnView(sym);
                }
            }
        });
    }
    public updateGameData(data:ParsedGameData):void{
        this._gameMode = data.mode;
        this._nextGameMode = data.nextMode;
        this._stopReelSet = data.reels[this._reelId];
    }

    /**
     * @inheritDoc
     * @override To re-order the symbols.
     */
    protected initReelStrip(): void {
        super.initReelStrip();
        if (!this._reelInitialized) {
            return;
        }

        this.reOrderSymbols();
    }

    /**
     * @inheritDoc
     * @param data
     */
    protected parseInitData(data: ParsedInitData): void {
        super.parseInitData(data);


    }

    /**
     * @inheritDoc
     * @param data
     */
    public onGameDataParsed(data: SpinParsedGameData): void {
        super.onGameDataParsed(data);


    }
    /**
     * @description To changes the state of scatter symbol w.r.t. anticipation.
     * @param state
     */
    public changeStateForScatter(state: ISymbolStateConfig): void {
        let sym: StateReelSymbol;

        for (let i = 1; i < 6; i++) {
            if (this._stopReelSet[i] === "S") {
                sym = this.findSymbol(i-1)!;
                if (sym) {
                    sym.changeState({
                        state: state
                    });
                }
            }
        }
    }
    public stopSpin(stopData: IReelStopSpinData, previousStopTime: number): number {
        let _this = this;
        this._reelPartAnimator.isQuickStop = stopData.quickStop;
        this._reelPartAnimator.isFastSpin = stopData.fastSpin;
        this._spinStopOffset = stopData.spinStopOffset;
        // Quick stop stopping reel
        if (this.currentState === ReelAnimationState.STOP_SPIN) {
            return this._spinReelPartAnimator.getStopTime(this._stopCounter - 1, false) + this.currentSpinStepLeftTime;
        }
        // Don't need to restore spin speed if quick stop near win?
        if (stopData.active) {
            let stopTimeTotal = this._spinReelPartAnimator.getStopTime(this._symNumTotal + this._spinStopOffset - 1, this.hasNearWin());
            if (this._reelPartAnimator.isQuickStop) {
                this._addedStopDelay = 0;
            }
            let stopTimerDelay = Math.max(0, previousStopTime + this.getStopDelayDelta(stopData) + this._addedStopDelay - stopTimeTotal);
            this._addedStopDelay = 0;
            if (this._reelStopDelayTimer && this._reelStopDelayTimer.isActive()) {
                // quick stop.
                let timelineLeftTime = this._reelStopDelayTimer.totalDuration() - this._reelStopDelayTimer.time();
                if (stopTimerDelay >= timelineLeftTime) {
                    return timelineLeftTime + stopTimeTotal;
                }
                this._reelStopDelayTimer.pause();
                this._reelStopDelayTimer.kill();
            }
            this._reelStopDelayTimer = TweenLite.to(this, stopTimerDelay, { onComplete: function () { return _this.clearStopDelay(); } });

            if(this._reelPartAnimator.isFastSpin){
                stopTimeTotal=  0;
            }
            return stopTimerDelay + stopTimeTotal + this.currentSpinStepLeftTime;
        }
        else {
            // If reel not active we fake a spin stopped so it actually send the event.
            EventHandler.dispatchEvent(new GameEvent(ReelEvent.REEL_STOP_SPIN_ANIMATION_COMPLETE, {
                reelId: this._reelId,
                fastSpin: this._reelPartAnimator.isFastSpin,
                quickStop: this._reelPartAnimator.isQuickStop,
                active: false
            }));
            return previousStopTime;
        };
    }


}